import type { SubcontractorMaster } from "../types";

/** Default list before API load or local-only mode — no bundled demo rows. */
export const initialSubcontractorMasters: SubcontractorMaster[] = [];
